module.exports = __webpack_public_path__ + "img/199ae03222ee49d0950fdf21db2fcc30-1024.556602a5.jpg";